<!-- 供应商应付款分析 -->
<template>
   <div class='page_content'>
      <div class="page_content_top">
         <div class="page_content_top_line">
            <el-form :inline="true" ref="getRequestData" label-width="100px" :model="getRequestData" class="demo-form-inline dis" size="mini" :inline-message="false" :show-message="false">
               <el-row>
                  <el-form-item label="开始日期" prop="start" :rules="[{required: true,  trigger: ['blur','change']}]">
                     <label slot="label" :style="$common.labelStyle('开始日期')" v-html="'开始日期'"></label>
                     <el-date-picker size="mini" v-model="getRequestData.start" format="yyyy 年 MM 月 dd 日" class="form_codition" value-format="timestamp" type="date" placeholder="选择日期"></el-date-picker>
                  </el-form-item>
                  <!-- <el-form-item label="结束日期" prop="end" :rules="[{required: true,  trigger: ['blur','change']}]">
                     <label slot="label" :style="$common.labelStyle('结束日期')" v-html="'结束日期'"></label>
                     <el-date-picker size="mini" v-model="getRequestData.end" @change="changeTime" class="form_codition" format="yyyy 年 MM 月 dd 日" value-format="timestamp" type="date" placeholder="选择日期">
                     </el-date-picker>
                  </el-form-item> -->
                  <!-- 检索方案 -->
                  <el-form-item label="单位名称" prop="smName" :rules="[{required: true,  trigger: ['blur','change']}]">
                     <label slot="label" :style="$common.labelStyle('单位名称')" v-html="'单位名称'"></label>
                     <el-input clearable v-model="getRequestData.smName" class="form_codition" @keyup.enter.native="openSearch('3386264207560704', 0, 'smName','smId,smName')">
                        <el-button @click="openSearch('3386264207560704', 0, 'smName','smId,smName')" slot="append" icon="el-icon-search"></el-button>
                     </el-input>
                  </el-form-item>
                  <el-form-item>
                     <el-button type="primary" size="mini" icon="el-icon-search" @click="searchData">查询</el-button>
                     <el-button type="primary" size="mini" @click="updata">导出</el-button>
                     <el-button type="primary" size="mini" @click="add">新增对账</el-button>
                     <el-button type="primary" size="mini" @click="see">查看对账</el-button>
                  </el-form-item>
               </el-row>
            </el-form>
         </div>
      </div>
      <div class="page_content_center">
         <u-table size="mini" id="tableData" :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" stripe ref="stockTable" :header-cell-style="{background:'#fff'}"
                  :row-height="35" row-key="index" use-virtual show-summary :summary-method="summaryMethod">
            <u-table-column align="center" show-overflow-tooltip prop="createTime" label="日期" min-width="140">
               <template slot-scope="scope">
                  <span v-if="scope.row.createTime">
                     {{$common.getLocalTime(scope.row.createTime)}}
                  </span>
               </template>
            </u-table-column>
            <u-table-column align="center" show-overflow-tooltip prop="businessId" label="单据编号" min-width="150">
            </u-table-column>
            <u-table-column align="center" show-overflow-tooltip prop="digest" label="摘要" min-width="120">
            </u-table-column>
            <u-table-column align="center" show-overflow-tooltip prop="jfMoney" label="借方金额" min-width="120">
            </u-table-column>
            <u-table-column align="center" show-overflow-tooltip prop="dfMoney" label="贷方金额" min-width="120"></u-table-column>
            <u-table-column align="center" show-overflow-tooltip prop="unitBalance" label="余额" min-width="120"></u-table-column>
            <u-table-column align="center" show-overflow-tooltip prop="opmName" label="业务员" :min-width="120"></u-table-column>
            <u-table-column align="center" show-overflow-tooltip prop="depName" label="部门名称" min-width="120"></u-table-column>
            <u-table-column align="center" show-overflow-tooltip prop="salesName" label="对方业务员" min-width="120"></u-table-column>
            <u-table-column align="center" show-overflow-tooltip prop="isDl" label="是否带量" :sortable="true" min-width="80"></u-table-column>
         </u-table>
      </div>
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
         <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <el-dialog title="新增对账" :visible.sync="addFlag" width="1000px" :before-close="handleClose">
         <el-form ref="formInline" :inline="true" :model="formInline" class="demo-form-inline" label-width="90px" :inline-message="false" :show-message="false">
            <el-row>
               <el-form-item label="对账人" prop="reconerName" :rules="[{required: true,  trigger: ['blur','change']}]">
                  <label slot="label" :style="$common.labelStyle('对账人')" v-html="'对账人'"></label>
                  <el-input clearable v-model="formInline.reconerName" class="form_codition" @keyup.enter.native="openSearch('4444770562019328', 0, 'reconerName','reconerId,reconerName')">
                     <el-button @click="openSearch('4444770562019328', 0, 'reconerName','reconerId,reconerName')" slot="append" icon="el-icon-search"></el-button>
                  </el-input>
               </el-form-item>
               <el-form-item label="对账日期" prop="reconDate" :rules="[{required: true,  trigger: ['blur','change']}]">
                  <!-- 退货申请日期 -->
                  <label slot="label" :style="$common.labelStyle('对账日期')" v-html="'对账日期'"></label>
                  <df-date v-model="formInline.reconDate" :isShowLong="false"></df-date>
               </el-form-item>
            </el-row>
            <el-row>
               <el-form-item label="上期金额" prop="preAmount" :rules="[{required: true,  trigger: ['blur','change']}]">
                  <label slot="label" :style="$common.labelStyle('上期金额')" v-html="'上期金额'"></label>
                  <el-input clearable v-model="formInline.preAmount" class="form_codition"></el-input>
               </el-form-item>
               <el-form-item label="对账金额" prop="takeAmount" :rules="[{required: true,  trigger: ['blur','change']}]">
                  <label slot="label" :style="$common.labelStyle('对账金额')" v-html="'对账金额'"></label>
                  <el-input clearable v-model="formInline.takeAmount" class="form_codition"></el-input>
               </el-form-item>
            </el-row>
            <el-row>
               <el-form-item label="图片上传" prop="fileUrl" :rules="[{required: true,  trigger: ['blur','change']}]">
                  <label slot="label" :style="$common.labelStyle('图片上传')" v-html="'图片上传'"></label>
                  <el-upload :headers="header" class="avatar-uploader" :action="`${imageUrl.url}/upload/fileupload`" :show-file-list="false" :on-success="handleAvatarSuccess">
                     <img v-if="formInline.fileUrl" :src="`${imageUrl.imgUrl}/${formInline.fileUrl}`" class="avatar">
                     <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
               </el-form-item>
            </el-row>
            <el-row>
               <el-form-item label="备注" prop="remark">
                  <label slot="label" :style="$common.labelStyle('备注')" v-html="'备注'"></label>
                  <el-input style="width: 500px;" type="textarea" :rows="2" v-model="formInline.remark">
                  </el-input>
               </el-form-item>
            </el-row>
         </el-form>
         <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="handleClose">取 消</el-button>
            <el-button type="primary" @click="onsubmit">确 定</el-button>
         </span>
      </el-dialog>
      <el-dialog title="查看" :visible.sync="seeFlag" width="1000px" :before-close="handleClose" top="10px">
         <u-table size="mini" id="tableData" :data="tableObj.list" height="350" :key="$store.state.tableNum" border style="width: 100%" stripe ref="stockTable" :header-cell-style="{background:'#fff'}" :row-height="35"
                  row-key="index" use-virtual>
            <u-table-column align="center" show-overflow-tooltip prop="unitName" label="单位名称" min-width="150"></u-table-column>
            <u-table-column align="center" show-overflow-tooltip prop="reconerName" label="对账人" min-width="150"></u-table-column>
            <u-table-column align="center" show-overflow-tooltip prop="reconDate" label="日期" min-width="140">
               <template slot-scope="scope">
                  <span v-if="scope.row.reconDate">
                     {{$common.getLocalTime(scope.row.reconDate)}}
                  </span>
               </template>
            </u-table-column>
            <u-table-column align="center" show-overflow-tooltip prop="preAmount" label="上期金额" min-width="120">
            </u-table-column>
            <u-table-column align="center" show-overflow-tooltip prop="takeAmount" label="对账金额" min-width="120">
            </u-table-column>
            <u-table-column align="center" show-overflow-tooltip prop="fileUrl" label="图片" min-width="120">
               <template slot-scope="scope">
                  <span v-if="scope.row.fileUrl">
                     <cusImage style="width: 30px; height: 30px;margin-top: 5px;" :src="`${imageUrl.imgUrl}/${scope.row.fileUrl}`" :preview-src-list="[`${imageUrl.imgUrl}/${scope.row.fileUrl}`]"></cusImage>
                  </span>
               </template>
            </u-table-column>
            <u-table-column align="center" show-overflow-tooltip prop="remark" label="备注" min-width="120"></u-table-column>
            <u-table-column align="center" label="操作" width="100" fixed="right">
               <template slot-scope="scope">
                  <el-button @click="delClick(scope.row)" type="danger" size="mini">删除</el-button>
               </template>
            </u-table-column>
         </u-table>
         <v-pagination :page="searchObj.page" :rows="searchObj.rows" :total="tableObj.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
      </el-dialog>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
   name: "supFinanicalRecoList",
   //import引入的组件需要注入到对象中才能使用
   data() {
      //这里存放数据
      return {
         header: {
            token: sessionStorage.getItem('token')
         },
         imageUrl: {
            url: "",
            imgUrl: "",
         },
         tableHeight: 0,
         getRequestData: {
            start: new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000,
            // end: new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1,
            smName: '',
         },
         returnData: {
            pages: 0, // 总页数
            total: 0, // 总条数
            pageNum: 0, // 当前页数
            list: [],
            pageSize: 10,
            dfhj: 0,//贷方
            jfhj: 0,//借方
            yehj: 0,//余额
         },
         seId: '',
         seIndex: '',
         sField: '',
         parentSearchData: {},
         seTitle: "",//检索
         DialogVisible: false,
         seWidth: '0',
         seType: '',
         addFlag: false,
         formInline: {
            reconDate: "",
            reconerName: "",
            reconerId: "",
            preAmount: "",
            takeAmount: "",
            fileUrl: "",
            remark: "",
            unitId: "",
         },
         seeFlag: false,
         tableObj: {
            pages: 0, // 总页数
            total: 0, // 总条数
            pageNum: 0, // 当前页数
            list: [],
            pageSize: 10
         },
         searchObj: {
            page: 1,
            rows: 30,
            smId: "",
            smName: "",
         }
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
      "getRequestData.reconerName": {
         handler: function (newValue, oldValue) {
            if (newValue == "") {
               this.getRequestData.reconerId = "";
            }
         },
         deep: true,
      },
      "getRequestData.smName": {
         handler: function (newValue, oldValue) {
            if (newValue == "") {
               this.getRequestData.smId = "";
            }
         },
         deep: true,
      },
   },
   //方法集合
   methods: {
      updata() {
         var listData = JSON.parse(JSON.stringify(this.returnData.list))
         var nameList = ["日期", "单据编号", "摘要", "借方金额", "贷方金额", "余额", "业务员", "部门名称", "对方业务员", "是否带量"]; //表格头 显示的所有字段
         var fieldList = ["createTime", "businessId", "digest", "jfMoney", "dfMoney", "unitBalance", "opmName", "depName", "salesName", "isDl"]; //所有字段 显示的所有字段
         listData.forEach(item => {
            for (const key in item) {
               if (key == 'createTime') {
                  item[key] = this.$common.getLocalTime(item[key])
               }
            }
         })
         // 导出业务逻辑 引用封装好的js方法
         require.ensure([], () => {
            const {
               export_json_to_excel
            } = require("@/assets/excel/Export2Excel");
            //这里使用绝对路径( @表示src文件夹 )，使用@/+存放export2Excel的路径
            const tHeader = nameList; // 导出的excel表头名信息
            const filterVal = fieldList; // 导出的excel表头字段名，需要导出表格字段名
            const list = listData; // 查询的数据list
            // 进行数据json map 格式转换
            const data = this.formatJson(filterVal, list);
            // 调用方法传参      表头名信息 数据  导出的表格名称
            export_json_to_excel(tHeader, data, "供应商财务对账");
         });
      },
      formatJson(filterVal, jsonData) {
         return jsonData.map((v) => filterVal.map((j) => v[j]));
      },
      summaryMethod({ columns, data }) {
         const means = [] // 合计
         columns.forEach((column, columnIndex) => {
            if (columnIndex === 0) {
               means.push('合计')
            } else if (columnIndex === 3) {
               means[columnIndex] = this.returnData.jfhj
            } else if (columnIndex === 4) {
               means[columnIndex] = this.returnData.dfhj
            } 
            //else if (columnIndex === 5) {
            //   means[columnIndex] = this.returnData.yehj
            //} 
            else {
               means[columnIndex] = ''
            }
         })
         return [means]
      },
      see() {
         if (this.getRequestData.smName == '') {
            return this.$message.error("请选择单位名称")
         }
         this.tableObj.list = []
         if (this.getRequestData.smName != "") {
            this.searchObj.smId = this.getRequestData.smId
            this.searchObj.smName = this.getRequestData.smName
         } else {
            this.searchObj.smId = ""
            this.searchObj.smName = ""
         }
         this.searchObj.page = 1
         this.seeFlag = true
         this.seeQuery()
      },
      async seeQuery() {
         const responseData = await this.$http.finanicalRecongetFinanicaRecord(this.searchObj)
         if (responseData.status == 200) {
            this.tableObj.list = responseData.result.list
            this.tableObj.total = responseData.result.total
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      handleClose() {
         this.seeFlag = false
      },
      add() {
         if (this.getRequestData.smName == "") {
            return this.$message.error("请先选择单位名称")
         } else {
            this.formInline.unitId = this.getRequestData.smId
            this.formInline.reconDate = new Date(new Date().toLocaleDateString()).getTime()
            this.addFlag = true
         }
      },
      async delClick(rows) {
         const res = await this.$http.finanicalReconDelFinanical({ ids: [rows.id] })
         if (res.status == 200) {
            this.seeQuery()
            this.$message.success(res.message)
         } else {
            this.$message({
               message: res.message,
               type: "error",
            });
         }
      },
      handleClose() {
         this.addFlag = false
         this.seeFlag = false
         this.init()
      },
      init() {
         for (const key in this.formInline) {
            if (key == 'reconDate') {
               this.formInline[key] = new Date(new Date()).getTime()
            } else {
               this.formInline[key] = ""
            }
         }
      },
      handleAvatarSuccess(res, file) {
         console.log(res);
         if (res.status == 200) {
            this.formInline.fileUrl = res.result[0].fileUrl
         } else {
            this.$message.error(res.message)
         }
      },
      onsubmit() {
         this.$refs['formInline'].validate(async (valid) => {
            if (valid) {
               const res = await this.$http.finanicalReconaddFinanical(this.formInline)
               if (res.status == 200) {
                  this.$message.success(res.message)
                  this.addFlag = false
                  this.init()
                  this.getDataList()
               } else {
                  this.$message({
                     message: res.message,
                     type: "error",
                  });
               }
            } else {
               return false;
            }
         });
      },
      getSeWidth(e) {
         // console.log(e);
         this.seWidth = e + "%";
      },
      getWidth(e) {
         // console.log(e);
         this.exWidth = e + "%";
      },
      getSearchName(e) {
         // console.log(e);
         this.seTitle = e;
      },
      //检索带回数据
      changeInputModel(val) {
         if (val != "" || val != undefined) {
            this.DialogVisible = false;
            if (this.seType == 'reconerName') {
               this.formInline.reconerName = val.opmName
               this.formInline.reconerId = val.opmId

            }
            this.paramValue(val)
         }
      },
      // 赋值字段
      paramValue(val) {
         let arr = this.sField.split(',')
         arr.forEach(item => {
            if (this.seeFlag) {
               this.searchObj[item] = val[item]
            } else {
               this.getRequestData[item] = val[item]

            }
         })
      },
      // 检索Id, 索引(表格中), 标识
      openSearch(sId, index, type, sField) {
         this.DialogVisible = true
         this.seType = type
         this.seId = sId
         this.sField = sField
         if (type == 'smName') {
            if (this.seeFlag) {
               this.parentSearchData[type] = this.searchObj[type]
            } else {
               this.parentSearchData[type] = this.getRequestData[type]
            }
         } else {
            if (type == 'reconerName') {
               this.parentSearchData.opmBuyer = ""
            }
         }
      },
      //获取当天最后时间戳
      changeTime(val) {
         if (val) {
            var time = val + 24 * 60 * 60 * 1000 - 1
            this.getRequestData.end = time
         }
      },
      toDetail(orderId) {
         console.log(orderId);
         this.$parent.toDetail(orderId);
         //    this.$parent.$parent.$parent.toDetail(orderId)
      },
      // 数据搜索
      searchData() {
         if (this.seeFlag) {
            this.searchObj.page = 1;
            this.seeQuery()
         }
         this.$refs['getRequestData'].validate((valid) => {
            if (valid) {
               this.getRequestData.page = 1;
               this.getDataList();
            } else {
               return false;
            }
         });

      },
      // 数据翻页
      setDataPageNumber(val) {
         if (this.seeFlag) {
            this.searchObj.page = val;
            this.seeQuery();
            return
         }
         this.getRequestData.page = val;
         this.getDataList();
      },

      // 切换显示条数
      setDataPageSize(val) {
         if (this.seeFlag) {
            this.searchObj.page = 1;
            this.searchObj.rows = val;
            this.seeQuery();
            return
         }
         this.getRequestData.page = 1;
         this.getRequestData.rows = val;
         this.getDataList();
      },

      // 获取数据列表
      async getDataList() {
         let responseData = await this.$http.finanicalRecongetSupFinanica(
            this.getRequestData
         );
         if (responseData.status == 200) {
            this.returnData.list = responseData.result.balanceVos
            this.returnData.dfhj = responseData.result.dfhj
            this.returnData.jfhj = responseData.result.jfhj
            //this.returnData.yehj = responseData.result.yehj
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },

   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      var obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
      for (const key in obj) {
         this.$set(this.getRequestData, key, obj[key])
      }
      this.imageUrl.url = window.global_config.BASE_URL
      this.imageUrl.imgUrl = window.global_config.BASE_IMG_URL
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() { this.tableHeight = this.$common.getTableHeight() - 20 },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() { this.tableHeight = this.$common.getTableHeight() - 20 }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.page_content_center {
   overflow-y: auto;
}

.dis {
   display: flex;
   flex-wrap: wrap !important;
}
::v-deep .avatar-uploader {
   border: 1px dashed #d9d9d9;
}
::v-deep .el-upload {
   border: 1px dashed #d9d9d9;
   border-radius: 6px;
   cursor: pointer;
   position: relative;
   overflow: hidden;
}
::v-deep .el-upload:hover {
   border-color: #409eff;
}
::v-deep .avatar-uploader-icon {
   font-size: 28px;
   color: #8c939d;
   width: 178px;
   height: 178px;
   line-height: 178px;
   text-align: center;
}
::v-deep .avatar {
   width: 178px;
   height: 178px;
   display: block;
}
</style>